
    // IMPORTS
    import { defineComponent, PropType, computed } from 'vue'
    import { MaterialListItem } from '@/types/material'
    import { ISearchMatch } from '@/types/search'

    export default defineComponent({
        name: 'searchMatchViewer',

        components: {
        },

        props: {
            node: { type: Object as PropType<MaterialListItem>, required: true },
            text: { type: String as PropType<string>, required: true },
            expectedMatchType: { type: String as PropType<string>, required: true },
            activeSearchMatch: { type: Object as PropType<ISearchMatch | null>, required: false, default: () => null },
            highlightColor: { type: String as PropType<string | null>, required: false, default: () => 'yellow' }
        },

        setup(props) {
            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const noHighlight = computed(() => props.activeSearchMatch == null ||
                props.expectedMatchType != props.activeSearchMatch.matchType ||
                props.node.id != props.activeSearchMatch.node.id)

            const isSimpleMatch = computed(() => props.activeSearchMatch?.matchRange == null)
            const rangeStartIndex = computed(() => props.activeSearchMatch?.matchRange?.startIndex ?? -1)
            const rangeEndIndex = computed(() => props.activeSearchMatch?.matchRange?.endIndex ?? -1)
            const rangeMatchPrefix = computed(() => props.text.substring(0, rangeStartIndex.value))
            const rangeMatchContent = computed(() => props.text.substring(rangeStartIndex.value, rangeEndIndex.value))
            const rangeMatchSuffix = computed(() => props.text.substring(rangeEndIndex.value))

            const computedData = { noHighlight, isSimpleMatch, rangeMatchPrefix, rangeMatchContent, rangeMatchSuffix }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...computedData }
        }
    });
